import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { WithContext as ReactTags } from 'react-tag-input';
import Api from '../../../services/Api';
import { fetchTagsInitAction } from '../../../actions/tagsActions';
import './TagsInput.scss';

const TagsInput = ({
  tags,
  placeholder,
  onChange,
  handleUpdatedTag,
}) => {
  const { tagsList } = useSelector(state => state.tags);
  const suggestions = tagsList.map(tag => ({
    id: tag.id.toString(),
    name: tag.name,
  }));
  const initialTags = tagsList.filter(x => tags.includes(x.id)).map(x => ({
    name: x.name,
    id: x.id.toString(),
  }));
  const [activeTags, setActiveTags] = useState(initialTags);
  const dispatch = useDispatch();
  const handleDelete = (i) => {
    const newTags = activeTags.filter((tag, index) => index !== i);
    setActiveTags(newTags);
    if (onChange) {
      onChange(newTags.map(t => parseInt(t.id, 10)));
    }
  };
  const handleAddition = (tag) => {
    const newTags = [...activeTags, tag];
    setActiveTags(newTags);
    if (onChange) {
      onChange(newTags.map(t => parseInt(t.id, 10)));
    }
    const exists = tagsList.find(x => x.name === tag.name);
    if (exists) {
      return;
    }
    Api.post('tags', { name: tag.name }, false).then((response) => {
      if (response.status === 201) {
        dispatch(fetchTagsInitAction());
      }
      handleUpdatedTag(response.data);
    });
  };
  const handleDrag = (tag, currentPosition, newPosition) => {
    const newTags = activeTags.slice();
    newTags.splice(currentPosition, 1);
    newTags.splice(newPosition, 0, tag);
    setActiveTags(newTags);
  };
  return (
    <div className="tags-input-container">
      <ReactTags
        tags={activeTags}
        labelField="name"
        delimiters={[188, 13, 9]}
        handleDelete={handleDelete}
        handleAddition={handleAddition}
        handleDrag={handleDrag}
        placeholder={placeholder}
        inputFieldPosition="bottom"
        suggestions={suggestions}
        autoComplete
      />
    </div>
  );
};

TagsInput.propTypes = {
  tags: PropTypes.array,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  handleUpdatedTag: PropTypes.func.isRequired,
};

TagsInput.defaultProps = {
  tags: [],
  placeholder: '',
  onChange: undefined,
};

export default TagsInput;
